<script>
/**
 * ****************************************************************************
 * @description     :   Main component for page Login
 * @created at      :   2023/03/02
 * @created by      :   ANS873 – baonx@ans-asia.com
 * @package         :   Best Security
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import template
 */
import template from './template.html';
import repository from '@/utils/repository';

/**
 * Define component chat for show page chat
 */
var LocationPopupSearch = {
    template: template,
    props: {
        onSelected: Function,
        initData: Object
    },
    created() {
        this.doSearch();
    },
    data() {
        return {
            search: '',
            resultSearch: []
        };
    },
    computed: {
        initObject() {
            return this.initData.customerno;
        }
    },
    methods: {
        doSearch: function () {
            repository
                .get(`ba/ba001000i/data/refer-gennba`, {
                    params: {
                        customerno: this.initObject,
                        locationname: this.search
                    }
                })
                .then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        this.resultSearch = data.Data;
                    } else {
                        this.resultSearch = [];
                    }
                });
        },
        selectFirstRow() {
            if (
                this.resultSearch &&
                this.resultSearch.length > 0 &&
                this.onSelected
            ) {
                this.onSelected(this.resultSearch[0]);
            }
        },
        selectRow(item) {
            if (this.onSelected) {
                this.onSelected(item);
            }
        }
    }
};
export default LocationPopupSearch;
</script>
